import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Layouts
import { CommonLayoutComponent } from './common/common-layout.component';
import { AuthenticationLayoutComponent } from './common/authentication-layout.component';
import { Page403Component } from './extras/403/403.component';
import { Page500Component } from './extras/500/500.component';


export const AppRoutes: Routes = [
    
    {
        path: '',
        redirectTo: '/authentication/sign-in',
        pathMatch: 'full',
    },
    {
        path: '',
        component: CommonLayoutComponent,
        children: [
            {
                path: 'dashboard',
                loadChildren: './dashboard/dashboard.module#DashboardModule'
            },
            {
                path: 'orders',
                loadChildren: './orders/orders.module#OrdersModule'
            },
            {
                path: 'reports',
                loadChildren: './reports/reports.module#ReportsModule'
            },
            {
                path: 'oprations',
                loadChildren: './oprations/oprations.module#OprationsModule'
            },
            {
                path: 'monitors',
                loadChildren: './monitors/monitors.module#MonitorsModule'
            },
            {
                path: 'users',
                loadChildren: './users/user.module#UserModule'
            },
            {
                path: 'details',
                loadChildren: './details/details.module#DetailsModule'
            },
            {
                path: '403',
                component: Page403Component,
            },
            {
                path: '500',
                component: Page500Component,
            }
        ]
    },
    
    {
        path: '',
        component: AuthenticationLayoutComponent,
        children: [
            {
                path: 'authentication',
                loadChildren: './extras/authentication.modules#AuthenticationModule'
            }
        ]
    },

];

